import React, {forwardRef} from 'react';

const Button = forwardRef(({className, ...props}, ref) => {
    return (
        <div className={"form-group"}>
            <div className={"col-sm-12"}>
                <button ref={ref} {...props} className={`btn form-control ${className}`}>{props.children}</button>
            </div>
        </div>
    );
});

export default Button;